import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'

import { StepQualify } from 'pages/chatbot/ui/ChatbotEdit/StepQualify'
import { StepHandoff } from 'pages/chatbot/ui/ChatbotEdit/StepHandoff'
import { useChatbotContext } from 'pages/chatbot/context'
import { StepEnrollment } from '../StepEnrollment'
import { StepFirstMessage } from '../StepFirstMessage'
import { StepConfigure } from '../StepConfigure'
import { StepObjective } from '../StepObjective'
import { StepSuccessActions } from '../StepSuccessActions'
import { StepFallbackActions } from '../StepFallbackActions'

import styles from './styles.module.scss'

export const ChatbotBody = observer(() => {
  const { validateTrigger } = useChatbotContext()
  const refBody = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!validateTrigger || !refBody.current) return

    const firstError = refBody.current.querySelector('[data-error]')
    if (!(firstError instanceof HTMLElement)) return

    const findScrollContainer = (element: HTMLElement | null): HTMLElement | null => {
      if (!element) return null
      const { overflowY } = getComputedStyle(element)
      return overflowY === 'scroll' || overflowY === 'auto'
        ? element
        : findScrollContainer(element.parentElement)
    }

    const scrollContainer = findScrollContainer(firstError.parentElement)
    if (!scrollContainer) return

    scrollContainer.scrollTo({
      top:
        scrollContainer.scrollTop +
        firstError.getBoundingClientRect().top -
        scrollContainer.getBoundingClientRect().top,
      behavior: 'smooth',
    })
  }, [validateTrigger])

  return (
    <div ref={refBody} className={styles.body}>
      <StepEnrollment />
      <StepFirstMessage />
      <StepConfigure />
      <StepObjective />
      <StepQualify />
      <StepHandoff />
      <StepSuccessActions />
      <StepFallbackActions />
    </div>
  )
})
